import React from 'react';

/**
 * Metric Card Component
 * Displays a key metric with optional trend and click handler
 */
const MetricCard = ({
  title,
  value,
  subtitle,
  icon,
  color = 'blue',
  trend,
  onClick,
  loading = false,
}) => {
  const colorClasses = {
    blue: 'metric-card--blue',
    green: 'metric-card--green',
    purple: 'metric-card--purple',
    orange: 'metric-card--orange',
    red: 'metric-card--red',
  };

  const getTrendIcon = (direction) => {
    if (direction === 'up') {
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    }
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 7L17 17M17 17H7M17 17V7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    );
  };

  if (loading) {
    return (
      <div className="metric-card metric-card--loading">
        <div className="metric-card__skeleton">
          <div className="metric-card__skeleton-icon"></div>
          <div className="metric-card__skeleton-content">
            <div className="metric-card__skeleton-value"></div>
            <div className="metric-card__skeleton-title"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div 
      className={`metric-card ${colorClasses[color]} ${onClick ? 'metric-card--clickable' : ''}`}
      onClick={onClick}
    >
      <div className="metric-card__header">
        <div className="metric-card__icon">{icon}</div>
        {trend && (
          <div className={`metric-card__trend metric-card__trend--${trend.direction}`}>
            {getTrendIcon(trend.direction)}
            <span>{trend.value}%</span>
          </div>
        )}
      </div>
      <div className="metric-card__content">
        <div className="metric-card__value">{value}</div>
        <div className="metric-card__title">{title}</div>
        {subtitle && <div className="metric-card__subtitle">{subtitle}</div>}
      </div>
    </div>
  );
};

export default MetricCard;
